const asyncCatch = (promise) => {
    return promise
        .then((data) => {
        if (data instanceof Error)
            return [data];
        return [null, data];
    })
        .catch((err) => [err]);
};
export default asyncCatch;
//# sourceMappingURL=asyncCatch.js.map